import { ref } from "vue";
import axiosInstance from "../config/axiosConfig.js";
import { useToast } from "vue-toastification";
import { useRouter } from "vue-router";

class JourneyService {
  constructor() {
    this.success = ref(false);
    this.message = ref("");
    this.errors = ref({});
    this.journeyListData = ref([]);
    this.idTypeListData = ref([]);
    this.ageGroupListData = ref([]);
    this.companyTripListData = ref([]);
    this.bookingListData = ref([]);
    this.journeyData = ref({});

    this.toast = useToast();
    this.router = useRouter();
  }

  async searchJourney(data) {
    try {
      const response = await axiosInstance.post(`/passenger/search-trips`, data);
      this.journeyListData.value = response.data.data ?? [];
      if (this.journeyListData.value.length === 0) {
        this.message.value = "No bus found for the selected route and date.";
      }
    } catch (e) {
      if (e.response && e.response.status === 422) {
        this.errors.value = e.response.data.errors;
      } else if (e.response && e.response.status === 401) {
        this.toast.error("Session expired.");
        this.router.replace({ path: "/" });
      }
    }
  }

  async bookTicket(data) {
    try {
      const response = await axiosInstance.post(`/passenger/book-ticket`, data);
      this.success.value = response.data.success;
      this.message.value = response.data.message;
      if (response.data.success) {
        this.bookingListData.value = response.data.data;
      }
    } catch (e) {
      this.success.value = false;
      if (e.response && e.response.status === 422) {
        this.errors.value = e.response.data.errors;
        this.message.value = Object.values(e.response.data.errors).flat().join(", ");
      } else if (e.response && e.response.status === 401) {
        this.toast.error("Session expired.");
        this.router.replace({ path: "/" });
      } else {
        this.message.value = e.response?.data?.message ?? "An error occurred while booking.";
      }
    }
  }

  async getJourney(id) {
    try {
      const response = await axiosInstance.get(`/passenger/search-trips/${id}`);
      this.journeyData.value = response.data.data ?? response.data;
    } catch (e) {
      if (e.response && e.response.status === 422) {
        this.errors.value = e.response.data.errors;
      } else if (e.response && e.response.status === 401) {
        this.toast.error("Session expired.");
        this.router.replace({ path: "/" });
      }
    }
  }

  async getIdTypes() {
    try {
      const response = await axiosInstance.get(`/passenger/id-types`);
      this.idTypeListData.value = response.data.data ?? [];
    } catch (e) {
      if (e.response && e.response.status === 422) {
        this.errors.value = e.response.data.errors;
      } else if (e.response && e.response.status === 401) {
        this.toast.error("Session expired.");
        this.router.replace({ path: "/" });
      }
    }
  }

  async getAgeGroups() {
    try {
      const response = await axiosInstance.get(`/passenger/age-groups`);
      this.ageGroupListData.value = response.data.data ?? [];
    } catch (e) {
      if (e.response && e.response.status === 422) {
        this.errors.value = e.response.data.errors;
      } else if (e.response && e.response.status === 401) {
        this.toast.error("Session expired.");
        this.router.replace({ path: "/" });
      }
    }
  }

  async getCompanyTripList() {
    try {
      const response = await axiosInstance.get(`/company_trips`, {
        params: { company_id: 104 },
      });
      if (response.data.success) {
        this.companyTripListData.value = response.data.data.trips;
      }
    } catch (e) {
      if (e.response && e.response.status === 422) {
        this.errors.value = e.response.data.errors;
      } else if (e.response && e.response.status === 401) {
        this.toast.error("Session expired.");
        this.router.replace({ path: "/" });
      }
    }
  }

  async checkSeatAvailability(data) {
    try {
      const response = await axiosInstance.post(
        `/passenger/reserve-ticket-temporary`,
        { journey_id: data.journey_id, seat_number: data.seat_number }
      );
      this.success.value = response.data.success;
      this.message.value = response.data.message;
    } catch (e) {
      this.success.value = false;
      if (e.response?.status === 422) {
        this.message.value = e.response.data.message || "Seat is not available.";
        this.errors.value = e.response.data.data || {};
      } else if (e.response?.status === 423) {
        this.message.value = e.response.data.message || "Seat is being processed, try again.";
      } else if (e.response?.status === 404) {
        this.message.value = e.response.data.message || "Journey not found.";
      } else if (e.response?.status === 401) {
        this.toast.error("Session expired.");
        this.router.replace({ path: "/" });
      }
    }
  }
}

export default JourneyService;
